(() => {
  const authRoutePattern = /\/(?:account|customers\/login|auth|authentication|login)(?:\/|\?|#|$)/i;

  const getCartUrl = () => window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;

  const redirectCartReturnUrl = () => {
    const currentUrl = new URL(window.location.href);
    if (!authRoutePattern.test(currentUrl.pathname)) return;

    const returnUrl =
      currentUrl.searchParams.get('return_url') ||
      currentUrl.searchParams.get('redirect_url') ||
      currentUrl.searchParams.get('checkout_url') ||
      '';

    if (!isCartUrl(returnUrl)) return;
    window.location.replace(getCartUrl());
  };

  const isCartUrl = (href) => {
    if (!href) return false;

    try {
      const url = new URL(href, window.location.origin);
      return /\/cart(?:\/|\?|#|$)/.test(url.pathname);
    } catch (error) {
      return /\/cart(?:\/|\?|#|$)/.test(href);
    }
  };

  const isCartEntry = (element) => {
    if (!element) return false;
    if (element.id === 'cart-icon-bubble' || element.id === 'cart-notification-button') return true;
    if (element.closest('cart-notification') && isCartUrl(element.getAttribute('href'))) return true;
    if (element.closest('cart-drawer') && isCartUrl(element.getAttribute('href'))) return true;
    return isCartUrl(element.getAttribute('href'));
  };

  try {
    redirectCartReturnUrl();
  } catch (error) {
    // Keep cart access available even if a browser blocks URL parsing in edge cases.
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest?.('a[href]');
      if (!isCartEntry(link)) return;

      const href = link.getAttribute('href') || '';
      if (!authRoutePattern.test(href)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(getCartUrl());
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      if (!isCartEntry(link)) return;
      const href = link.getAttribute('href') || '';
      if (authRoutePattern.test(href)) link.setAttribute('href', getCartUrl());
    });
  });
})();
